// extracted by mini-css-extract-plugin
export default {"main-layout":"styles_main-layout__P-6az","skill-fields-container":"styles_skill-fields-container__b7V7n","disabled":"styles_disabled__tneZq"};